import { defineMessages } from "react-intl";

export default defineMessages({
    allocationsHeader: { id: "allocations.allocationsHeader", defaultMessage: "Allocations", description: "Allocations: Allocations" },
});